import React from 'react';
import classNames from 'classnames';

const SkeletonLoader = ({ className }: { className: string }): JSX.Element => (
  <div className={classNames('bg-[#888] opacity-10 animate-skeleton rounded-lg', className)}></div>
);

export default SkeletonLoader;
